export default {
  title: 'Nowa marka',
  tabs: {
    general: 'Ogólne',
    branding: 'Branding',
    scripts: 'Skrypty',
    tracking: 'Śledzenie',
    domain: 'Domena',
  },
  fields: {
    name: {
      label: 'Nazwa',
      placeholder: 'Nazwa marki',
    },
    slug: {
      label: 'Subdomena',
      placeholder: 'Subdomena marki',
      hint: 'Małe litery, cyfry i myślniki. Razem z domeną sklepu tworzy adres sklepu.',
      preview: 'Adres sklepu: {{url}}',
      availability: {
        taken: 'Inna marka używa już tej subdomeny w tej domenie sklepu.',
        reserved: 'Ta subdomena jest zarezerwowana. Należy wybrać inną.',
        invalid_label:
          'W tej domenie sklepu subdomena może zawierać tylko małe litery, cyfry i myślniki, musi zaczynać się i kończyć literą lub cyfrą i może mieć najwyżej 63 znaki.',
        taken_elsewhere: 'Marka w innej domenie sklepu używa już tej subdomeny. Należy wybrać inną.',
        format: 'Używaj wyłącznie liter, cyfr, myślników i podkreśleń.',
        unavailable: 'Ta subdomena jest niedostępna. Należy wybrać inną.',
      },
    },
    shop_domain_id: {
      label: 'Domena sklepu',
      placeholder: 'Wybierz domenę sklepu',
      move_warning: {
        title: 'To zmienia adres sklepu, którego używają klienci',
        description:
          'Po zapisaniu sklep będzie pod adresem {{url}}. Kody QR, ulotki i linki już wydrukowane lub udostępnione ze starym adresem przestaną działać.',
      },
    },
    lieferando_url: {
      label: 'Lieferando URL',
      placeholder: 'URL restauracji w Lieferando',
    },
    primary_color: {
      label: 'Kolor główny',
    },
    logo: {
      label: 'Logo',
    },
    image: {
      label: 'Zdjęcie',
    },
    companies: {
      label: 'Restauracje',
    },
    noscripts: {
      description: 'Wstaw kod zaraz po otwarciu body',
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: 'Facebook Conversion Access Token',
    },
    google_analytics_id: {
      label: 'Google Analytics ID',
    },
    google_ads_conversion_label_id: {
      label: 'Etykieta konwersji Google Ads',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Własna domena sklepu internetowego',
    },
  },
  buttons: {
    save: 'Zapisz',
    close: 'Zamknij',
    sync_from_lieferando: 'Synchronizuj z Lieferando',
  },
  toasts: {
    changes_saved_successfully: 'Zmiany zostały pomyślnie zapisane!',
    failed_to_update_company_slug: 'Nie udało się zaktualizować slug dla {{name}}',
    failed_to_sync_lieferando: 'Nie udało się zsynchronizować danych z Lieferando',
    successfully_synced_lieferando: 'Dane zostały pomyślnie zsynchronizowane z Lieferando',
    failed_to_load_shop_domains: 'Nie udało się wczytać domen sklepu.',
    logo_file_too_large: 'Logo jest za duże. Maksymalny rozmiar to {{max}} MB.',
    logo_dimensions_too_large: 'Logo jest za duże. Szerokość i wysokość mogą wynosić maksymalnie {{max}} px.',
  },
};
